import "./styles.scss";

const Hairstyle = ({ number, name, description, price }) => {
  return (
    <div className="hairstyleContainer">
      <div className="number">
        <span style={{ top: 10, right: 25 }} className="hashtag">
          #
        </span>
        {number}
      </div>
      <div className="name">{name}</div>
      <div className="description">{price} lei</div>
      <div className="description">{description}</div>
    </div>
  );
};

export default Hairstyle;
